import { useState } from "react";
import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";

export const HowItWorksModal = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="t-mr-auto">
        <Button customType="ghost" onClick={() => setOpen(true)} type="button">
          How it works?
        </Button>
      </div>

      <Modal.Root open={open} onOpenChange={setOpen}>
        <Modal.Content size="regular">
          <Modal.Header>
            <Modal.Title>How it works</Modal.Title>
            <Modal.Close />
          </Modal.Header>

          <Modal.Body className="sm:t-px-4">
            <div className="t-flex t-flex-col t-gap-2 t-font-normal t-text-body-sm t-text-text-60">
              <p>
                1. Chart of accounts are imported from the Account List report
              </p>
              <p>
                2. Bank accounts fetched from Account List report will be mapped
                to data connections
              </p>
              <p>
                3. Account type fetched from Account List report will be mapped
                to categories in Inkle Books
              </p>
              <p>
                4. Opening balances for each category, as of the start of the
                financial year, will come from last year's balance sheet
              </p>
              <p>5. Vendors will be imported from Vendors list</p>
              <p>6. Customers will be imported from Customers list</p>
              <p>
                7. Journal entries imported from Journal report will update
                balances till the current date
              </p>
              <p>
                8. Based on the journal type, invoices, bills and bank
                transactions will be created
              </p>
              <p>
                9. Invoices will be linked to bank transactions and marked paid
                based on Invoices & Received Payments report
              </p>
              <p>
                10. Bills will be linked to bank transactions and marked paid
                based on Bills & Applied Payments report
              </p>
              <p>
                11. Existing data in Inkle Books will be deleted up to the
                import cutoff date
              </p>
            </div>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
};
